import { configureStore, combineReducers } from '@reduxjs/toolkit';

import authReducer from '@/features/auth/stores/authSlice';
import dashboardReducer from '@/features/dashboard/stores/dashboardSlice';
import annotationsReducer from '@/features/map/stores/annotationsSlice';
import layerReducer from '@/features/map/stores/layerSlice';
import mapReducer from '@/features/map/stores/mapSlice';
import realtimeReducer from '@/features/realtime/stores/realtimeSlice';
import reportsReducer from '@/features/reports/stores/reportSlice';
import scenarioReducer from '@/features/scenario/stores/scenarioSlice';

import { baseApi } from './api';
import { geoProcessingApi } from './geoProcessingApi';
import '@/features/dashboard/api/dashboardApi';
import '@/features/admin/api/opsManagementApi';
import '@/features/menus/api/menusApi';
import '@/features/menus/api/roleFeatureMatrixApi';
import { performanceMiddleware } from './middleware/performanceMiddleware';
import { socketMiddleware } from './middleware/socketMiddleware';

const rootReducer = combineReducers({
  [baseApi.reducerPath]: baseApi.reducer,
  [geoProcessingApi.reducerPath]: geoProcessingApi.reducer,
  auth: authReducer,
  map: mapReducer,
  annotations: annotationsReducer,
  layer: layerReducer,
  realtime: realtimeReducer,
  dashboard: dashboardReducer,
  scenario: scenarioReducer,
  reports: reportsReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['realtime/dataReceived', 'realtime/batchDataReceived', 'socket/connect'],
      },
    })
      .concat(baseApi.middleware)
      .concat(geoProcessingApi.middleware)
      .concat(socketMiddleware)
      .concat(performanceMiddleware),
  devTools: import.meta.env.DEV,
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
